import { PencilBaseIcon } from '@tableau/icons/PencilBaseIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

export type EditRoutingFilterButtonProps = Readonly<{
  onClick: () => void;
  disabled?: boolean;
}>;

export function EditRoutingFilterButton(props: EditRoutingFilterButtonProps) {
  return (
    <ButtonWidget
      testId="edit-routing-filter-button"
      buttonType={ButtonType.Icon}
      onClick={props.onClick}
      title={Messages.edit()}
      aria-label={Messages.edit()}
      disabled={props.disabled}
    >
      <PencilBaseIcon size={14} aria-hidden={true} />
    </ButtonWidget>
  );
}
